import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-outsource-offshore',
  templateUrl: './why-outsource-offshore.component.html',
  styleUrls: ['./why-outsource-offshore.component.css']
})
export class WhyOutsourceOffshoreComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/why-outsource-offshore/why-outsource-offshore.component.ts